import { useContext } from "react";
import { UserContext, UserContextValue } from "../../context/user.context";

export function useUser(): UserContextValue {
  return useContext(UserContext);
}
